import React, { useState, useEffect } from "react";
import { Input, Button, Select, message, Checkbox, Form } from "antd";
import { ClipLoader } from "react-spinners";
import { useNavigate, useParams } from "react-router-dom";
import { editPlatformKey, getPlatformKeybyId } from "../../../API/Admin/platformKeys";
import {
  PlusOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";

import "./style.css"

const ViewAPIDetails = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const { id } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const res = await getPlatformKeybyId(id);

        const data = res.data?.platform || res.data;

        const formatted = {
          platformName: data.platform_name,
          key: data.key,
          description: data.description,
          value: data.value,
        };

        form.setFieldsValue(formatted);
      } catch (error) {
        message.error("Failed to load platform details");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchData();
  }, [id, form]);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const payload = {
        id,
        value: values.value,
      };

      await editPlatformKey(payload);

      message.success("Configuration updated successfully!");
      navigate("/api-accounts");
    } catch (error) {
      message.error("Failed to update configuration");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/api-accounts");
  };

  if (loading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        className="loader-container"
      >
        <ClipLoader size={50} color={"#123abc"} loading={loading} />
      </div>
    );
  }
  return (
    <div className="api">
      <Form form={form} layout="vertical" onFinish={handleSubmit}>

        <div className="edit-api">
          <div className="heading">Edit API Account</div>

          <div className="api-details">

            <div className="input-group">
              <div className="title">Platform Name</div>
              <Form.Item name="platformName">
                <Input disabled />
              </Form.Item>
            </div>

            <div className="input-group">
              <div className="title">Configuration Key</div>
              <Form.Item name="key">
                <Input disabled />
              </Form.Item>
            </div>

            <div className="input-group">
              <div className="title">Description</div>
              <Form.Item name="description">
                <Input.TextArea
                  rows={3}
                  disabled
                />
              </Form.Item>
            </div>

            <div className="input-group">
              <div className="title">Value</div>
              <Form.Item
                name="value"
                rules={[
                  {
                    required: true,
                    message: "Value is required",
                  },
                ]}
              >
                <Input.Password
                  placeholder="Enter Value"
                />
              </Form.Item>
            </div>

          </div>
        </div>

        {/* ACTIONS */}
        <div className="form-actions">
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" htmlType="submit">
            Save Changes
          </Button>
        </div>

      </Form>
    </div>
  );
};

export default ViewAPIDetails;
